import { IIconProps } from "../types"

export default function IconLL5(props: IIconProps) {
  const width = props.size || props.width || 56
  const height = props.size || props.height || 69
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 56 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.0494 0.803303C28.6694 0.503303 25.9394 0.303303 22.9194 0.583303C19.9094 0.853303 16.6294 1.6033 13.9094 2.4733C11.1894 3.3333 9.03938 4.3133 7.52938 5.2333C6.00938 6.1633 5.12938 7.0433 4.21938 7.9733C3.30938 8.9033 2.36938 9.8733 1.75938 11.1433C1.15938 12.4133 0.899376 13.9733 0.709376 16.0233C0.509376 18.0833 0.379376 20.6133 0.489376 24.4233C0.609376 28.2333 0.969376 33.3133 1.63938 39.2033C2.29938 45.0933 3.27938 51.8033 4.21938 56.0033C5.16938 60.2033 6.07938 61.8933 7.39938 63.1833C8.70938 64.4633 10.4394 65.3433 12.4894 66.1133C14.5394 66.8733 16.9194 67.5233 19.1994 67.7833C21.4794 68.0433 23.6594 67.9133 25.7994 67.3433C27.9494 66.7733 30.0694 65.7633 32.0894 64.0233C34.0994 62.2833 36.0294 59.8133 39.0694 54.8333C42.1094 49.8533 46.2794 42.3633 49.0494 36.9133C51.8094 31.4533 53.1794 28.0433 53.9894 25.5133C54.8094 22.9933 55.0694 21.3633 55.0394 19.9133C54.9994 18.4733 54.6794 17.2033 54.2194 16.0133C53.7694 14.8233 53.1794 13.7133 52.0594 12.4433C50.9294 11.1733 49.2694 9.7433 46.7494 7.9733C44.2294 6.1933 40.8394 4.0833 38.1394 2.8133C35.4394 1.5433 33.4194 1.1133 31.0494 0.803303Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.9"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
